import fetch from 'isomorphic-fetch';
import TagManager from 'react-gtm-module';
import { checkHttpStatus, getPagePath, parseJSON } from '../utils';
import {
  METADATA_REQUEST,
  METADATA_SUCCESS,
  METADATA_FAILURE,
} from '../constants';
import { initializeGTMWithEvent } from '../utils/googleTagManager';

export function metadataRequest() {
  return {
    type: METADATA_REQUEST
  };
}

export function metadataSuccess(metadata) {
  return {
    type: METADATA_SUCCESS,
    payload: {
      data: metadata,
    },
  };
}

export function metadataFailure() {
  return {
    type: METADATA_FAILURE,
  };
}

export function getMetadataForPage(path) {
  return dispatch => {
    dispatch(metadataRequest());
    const queryString = window.location.search;
    return fetch(`${SERVER_URL}/get_metadata.json${queryString}`, {
      method: 'POST',
      body: JSON.stringify({ path }),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(checkHttpStatus)
      .then(parseJSON)
      .then((response) => {
        const { title = 'Explore.org' } = response.data;
        initializeGTMWithEvent({
          event: 'pageview',
          pagedata: {
            path: getPagePath(),
            title,
          },
        });
        dispatch(metadataSuccess(response.data));
      })
      .catch((error) => {
        dispatch(metadataFailure());
      });
  };
}
